import loadable from '@loadable/component';

/**
 * Code-split wrapper for SearchByImagePopover — keeps it out of the initial bundle; it renders nothing at
 * first paint. Jest maps `*.loadable` modules to their eager originals (see jest.config.cjs).
 */
export const SearchByImagePopover = loadable(
    /* #__LOADABLE__ */
    () => import('./SearchByImagePopover'),
    {
        resolveComponent: (components) => components.SearchByImagePopover,
        ssr: false,
    }
);
